import clientSideEnvironmentVariablesConfig from '../config/clientSideEnvironmentVariables.json';
import { isNode, isProductionMode } from './environment';

const { allowedKeys, injectionKey } = clientSideEnvironmentVariablesConfig;

const getRuntimeConfiguration = (variableName) => {
  if (isNode()) {
    return process.env[variableName];
  }
  if (!allowedKeys.includes(variableName)) {
    if (!isProductionMode()) {
      throw new Error(`Variable ${variableName} is not accessible on the client.`);
    }
    return null;
  }
  return window[injectionKey]?.[variableName];
};

export default getRuntimeConfiguration;
